/* eslint-disable operator-linebreak */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
// In src/App.js
import React from 'react'
import { Admin, Resource } from 'react-admin'
import SportsTennisIcon from '@material-ui/icons/SportsTennis'
import GroupIcon from '@material-ui/icons/Group'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { englishMessages } from './i18n/en'
import { frenchMessages } from './i18n/fr'
import HttpProvider from './providers/http/provider'
import authProvider from './providers/http/authProvider'
import { IDENTIFIERS as RESOURCE_IDENTIFIERS } from './config/resources'
import addUploadCapabilities from './providers/http/addUploadCapabilities'
import TournamentsList from './pages/tournaments/TournamentsList'
import TournamentEdit from './pages/tournaments/TournamentEdit'
import UsersList from './pages/users/UsersList'
import LoginForm from './pages/login/LoginForm'
import UserEdit from './pages/users/UserEdit'
import ClubsList from './pages/clubs/ClubsList'
import ClubEdit from './pages/clubs/ClubEdit'

const messages = {
  fr: frenchMessages,
  en: englishMessages,
}
const i18nProvider = polyglotI18nProvider((locale) => messages[locale], 'fr')

const App = () => (
  <Admin
    /* Theme={theme} */
    locale="fr"
    i18nProvider={i18nProvider}
    dataProvider={addUploadCapabilities(HttpProvider)}
    authProvider={authProvider}
    loginPage={LoginForm}
    disableTelemetry
  >
    <Resource
      options={{ label: 'Tournois' }}
      name={RESOURCE_IDENTIFIERS.TOURNAMENTS}
      list={TournamentsList}
      edit={TournamentEdit}
      icon={SportsTennisIcon}
    />
    <Resource
      options={{ label: 'Utilisateurs' }}
      name={RESOURCE_IDENTIFIERS.USERS}
      list={UsersList}
      edit={UserEdit}
      icon={GroupIcon}
    />
    <Resource options={{ label: 'Clubs' }} name={RESOURCE_IDENTIFIERS.CLUBS} list={ClubsList} edit={ClubEdit} />
  </Admin>
)
export default App
